import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paginate from 'react-paginate';
import BlogPost from './BlogPost';
import './blogList.css';

class BlogList extends Component {
  constructor(props) {
    super(props);
    this.blogList = props.posts.filter(post => post.node.frontmatter.templateKey === 'article-page');
    this.limit = props.itemsPerPage || 5;
    this.isfrontPage = props.isFrontPage || false;
    this.state = {
      data: this.blogList.slice(0, this.limit),
      offset: 0,
      pageCount: Math.ceil(this.blogList.length / this.limit),
    };
  }

  handlePageClick = data => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.limit);
    this.setState({
      ...this.state,
      offset,
      data: this.blogList.slice(offset, offset + this.limit),
    });
  };

  render() {
    const isFrontPage = this.isfrontPage;
    return (
      <div>
        <BlogPost posts={this.state.data} />
        {isFrontPage == false ? (
        <div className='pager-container'>
          <Paginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={<a href=''>...</a>}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={this.handlePageClick}
            activeClassName={'active'}
            breakClassName={'pager-button'}
            containerClassName={'pager'}
            pageClassName={'pager-button'}
            previousClassName={'previous pager-button'}
            nextClassName={'next pager-button'}
          />
        </div>) : (null)}
      </div>
    );
  }
}

BlogList.propTypes = {
  posts: PropTypes.object.isRequired,
  itemsPerPage: PropTypes.number,
};

export default BlogList;



// WEBPACK FOOTER //
// ./src/components/BlogPost/BlogList.js